<template>
  <main>
    <PageHeaderUI
      title="Book New Shipment"
      breadcrumb="Dashboard > Bookings > New Booking Request"
    />
    <user-domains />
  </main>
</template>

<script>
import UserDomains from "@/components/Ondemand/Bookings/BookingFlow.vue";
import PageHeaderUI from "@/components/Ondemand/UI/PageHeaderUI.vue";

export default {
  components: {
    UserDomains,
    PageHeaderUI,
  },
};
</script>

<style></style>
